<div class="container">
  <!-- section title -->
  <h2 class="section-title wow fadeInUp">Services</h2>

  <div class="spacer-60"></div>

  <div class="row">

    <div class="col-md-4">
      <!-- service box -->
      <div class="service-box rounded data-background padding-30 text-center shadow-yellow bg-yellow">
        <img src="assets/images/service-2.svg" alt="UI/UX design" />
        <h3 class="mb-3 mt-0">Front End Web Development</h3>
        <p class="mb-0">Make your website look awesome with my front-end development service! I create cool designs that are easy to use, making your site stand out and impress your visitors.</p>
      </div>
      <div class="spacer-30 d-md-none d-lg-none"></div>
    </div>


    <div class="col-md-4">
      <!-- service box -->
      <div class="service-box rounded data-background padding-30 text-center text-light shadow-pink bg-pink">
        <img src="assets/images/service-3.svg" alt="UI/UX design" />
        <h3 class="mb-3 mt-0">Canva Designing</h3>
        <p class="mb-0">Make your brand pop with Canva! I specialize in creating eye-catching graphics for social media or anything else you need. Let's make your brand look awesome!</p>
      </div>
    </div>
    <div class="col-md-4">
      <!-- service box -->
      <div class="service-box rounded data-background padding-30 text-center text-light shadow-blue bg-blue">
        <img src="assets/images/service-1.svg" alt="UI/UX design" />
        <h3 class="mb-3 mt-0">UI/UX design</h3>
        <p class="mb-0">I turn your ideas into pretty designs using Figma. From sketches to the final look, I create designs that match your brand. It's a smooth process from thinking about it to making it real.</p>
      </div>
      <div class="spacer-30 d-md-none d-lg-none"></div>
    </div>



    
  </div>
  <div class="row mt-5">

    <div class="col-md-4">
      <!-- service box -->
      <div class="service-box rounded data-background padding-30 text-center shadow-yellow bg-yellow">
        <img src="assets/images/service-2.svg" alt="UI/UX design" />
        <h3 class="mb-3 mt-0">Dynamic Website Service with Angular
        </h3>
        <p class="mb-0">Want a website that's interactive and modern? I use Angular to make your website more exciting and user-friendly. Let's bring your ideas to life and make your site stand out!</p>
      </div>
      <div class="spacer-30 d-md-none d-lg-none"></div>
    </div>


    <div class="col-md-4">
      <!-- service box -->
      <div class="service-box rounded data-background padding-30 text-center text-light shadow-pink bg-pink">
        <img src="assets/images/service-2.svg" alt="UI/UX design" />
        <h3 class="mb-3 mt-0">Static Website Service
        </h3>
        <p class="mb-0">Get a simple and fast website that looks great! I create static websites in HTML CSS And JavaScript that show off your stuff in a clear way. No fuss, just straightforward design to get your message across.</p>
      </div>
    </div>
    <div class="col-md-4">
      <!-- service box -->
      <div class="service-box rounded data-background padding-30 text-center text-light shadow-blue bg-blue">
        <img src="assets/images/service-1.svg" alt="UI/UX design" />
        <h3 class="mb-3 mt-0">Document Design & Formatting Services

        </h3>
        <p class="mb-0">Crafting polished presentations and elegant layouts, I ensure your business materials make a lasting impression using Microsoft Office and InPage.</p>
      </div>
      <div class="spacer-30 d-md-none d-lg-none"></div>
    </div>



    
  </div>
  <div class="mt-5 text-center">
    <p class="mb-0">Looking for a custom job? <a href="javascript:" (click)="scrollTo('contact')">Click here</a> to contact me! 👋</p>
  </div>
</div>
